<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <div class='row h-row-around-inputBox'>
      <div class='col-sm-6'>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.nodeSelect')}}:</div>
          <div class='h-borderBox h-filterTopoTree height-464'>
            <TopoTree ref='filterTopoTree' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true'></TopoTree>
          </div>
        </div>
      </div>
      <div class='col-sm-6'>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.createTime')}}:</div>
          <ejs-daterangepicker  :format='dateFormat' v-model='createTime'></ejs-daterangepicker>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.clearTime')}}:</div>
          <ejs-daterangepicker :format='dateFormat' v-model='clearTime'></ejs-daterangepicker>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.confirmTime')}}:</div>
          <ejs-daterangepicker :format='dateFormat' v-model='confirmTime'></ejs-daterangepicker>
        </div>
        <div v-if='hasStatus' class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.clearState')}}:</div>
          <ejs-dropdownlist :dataSource='clearStatus' :placeholder='listPlaceholder' :fields='clearFields' v-model='conditions.alarmState.clearState'></ejs-dropdownlist>
        </div>
        <div v-if='hasStatus' class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.confirmState')}}:</div>
          <ejs-dropdownlist :dataSource='confirmStatus' :placeholder='listPlaceholder' :fields='clearFields' v-model='conditions.alarmState.confirmState'></ejs-dropdownlist>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmLevel')}}:</div>
          <div class='row' id='alarmLevelBox'>
            <div v-for='(alarm, index) in alarmLevelList' :key='index' class='col-sm-3 nopadding'>
              <ejs-checkbox :label='alarm.label' :value='alarm.value' :checked='alarm.checked'></ejs-checkbox>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmType')}}:</div>
          <div class='row' id='alarmTypeBox'>
            <div v-for='(alarm, index) in alarmTypeList' :key='index' class='col-sm-3 nopadding'>
              <ejs-checkbox :label='alarm.label' :value='alarm.value' :checked='alarm.checked'></ejs-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='h-clear-rowMg'></div>
  </div>
</template>
<script>
import TopoTree from '../../topoconfig/TopoTree';
export default {
  name: 'alarmFilter',
  components: {
    TopoTree
  },
  props: {
    hasStatus: { type: Boolean, default: false },
    url: { type: String, default: '' }
  },
  data() {
    return {
      waterMarkText: 'Select a Range',
      dateFormat: 'yyyy-MM-dd',
      listPlaceholder: this.$t('Alarm.pleaseChoose'),
      clearFields: {
        text: 'name',
        value: 'code'
      },
      topoList: [],
      clearStatus: [
        { name: this.$t('Alarm.pleaseChoose'), code: '-1' },
        { name: this.$t('Alarm.alarmClearStatus_0'), code: '0' },
        { name: this.$t('Alarm.alarmClearStatus_1'), code: '1' }
      ],
      confirmStatus: [
        { name: this.$t('Alarm.pleaseChoose'), code: '-1' },
        { name: this.$t('Alarm.alarmConfirmStatus_0'), code: '0' },
        { name: this.$t('Alarm.alarmConfirmStatus_1'), code: '1' }
      ],
      alarmLevelList: [
        { label: this.$t('Alarm.alarmLevel_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmLevel_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmLevel_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmLevel_3'), value: '3', checked: false }
      ],
      alarmTypeList: [
        { label: this.$t('Alarm.alarmType_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmType_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmType_2'), value: '2', checked: false }],
      createTime: '',
      clearTime: '',
      confirmTime: '',
      conditions: {
        alarmTime: {
          createTime: '',
          clearTime: '',
          confirmTime: ''
        },
        alarmLevel: [],
        alarmType: [],
        ne: []
      }
    };
  },
  watch: {
    createTime(val) {
      this.conditions.alarmTime.createTime = this.turnToFormateDateStr(val);
    },
    clearTime(val) {
      this.conditions.alarmTime.clearTime = this.turnToFormateDateStr(val);
    },
    confirmTime(val) {
      this.conditions.alarmTime.confirmTime = this.turnToFormateDateStr(val);
    }
  },
  methods: {
    turnToFormateDateStr(val) {
      let str = '';
      if (!!val && val.length > 0) {
        const startTime = this.turnToFormateDate(new Date(val[0]));
        const endTime = this.turnToFormateDate(new Date(val[1]));
        str = `${startTime} - ${endTime}`;
      }
      return str;
    },
    turnToFormateDate(dateValue) {
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day}`;
    },
    turnToDateList(val) {
      if (val) {
        const list = val.split(' - ');
        for (let i = 0; i < list.length; i++) {
          list[i] = new Date(list[i]);
        }
        return list;
      }
      return '';
    },
    getArray(id) {
      const checkedDom = document.querySelectorAll(`#${id} [aria-checked=true] input`);
      const array = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
      }
      return array;
    },
    setConditions(json) {
      if (json) {
        const conditions = JSON.parse(json);
        this.conditions = conditions;
        this.createTime = this.turnToDateList(this.conditions.alarmTime.createTime);
        this.clearTime = this.turnToDateList(this.conditions.alarmTime.clearTime);
        this.confirmTime = this.turnToDateList(this.conditions.alarmTime.confirmTime);
        for (let i = 0; i < this.alarmLevelList.length; i++) {
          for (let j = 0; j < this.conditions.alarmLevel.length; j++) {
            if (this.alarmLevelList[i].value === this.conditions.alarmLevel[j]) {
              this.alarmLevelList[i].checked = true;
            }
          }
        }
        for (let i = 0; i < this.alarmTypeList.length; i++) {
          for (let j = 0; j < this.conditions.alarmType.length; j++) {
            if (this.alarmTypeList[i].value === this.conditions.alarmType[j]) {
              this.alarmTypeList[i].checked = true;
            }
          }
        }
        this.$refs.filterTopoTree.uncheckAll();
        this.$refs.filterTopoTree.neIdListCache = {};
        for (let i = 0; i < this.topoList.length; i++) {
          this.$refs.filterTopoTree.neIdListCache[`${this.topoList[i]}`] = true;
        }
        this.$refs.filterTopoTree.change('');
      }
    },
    getConditions() {
      this.conditions.alarmLevel = this.getArray('alarmLevelBox');
      this.conditions.alarmType = this.getArray('alarmTypeBox');
      const neIdList = [];
      const nodeList = this.$refs.filterTopoTree.getNodeList();
      this.topoList = [];
      for (let i = 0; i < nodeList.length; i++) {
        if (nodeList[i].typeCode <= 20000) {
          neIdList.push(nodeList[i].id);
          this.topoList.push(nodeList[i].id);
        }
      }
      if (!this.hasStatus) {
        this.conditions.alarmState = {
          clearState: 1,
          confirmState: 1
        };
      }
      this.conditions.nodeIds = neIdList;
      return JSON.stringify(this.conditions);
    },
    setTopoList(data) {
      this.topoList = data;
    },
    getTopoList() {
      return this.topoList;
    }
  },
  created() {
    if (this.hasStatus === true) {
      this.conditions.alarmState = {
        clearState: '',
        confirmState: ''
      };
    }
    // this.$axios.get(this.url).then((response) => {
    //   this.alarmTypeList = [];
    //   if (response && response.status === 200) {
    //     for (let i = 0; i < response.data.alarmTypes.length; i++) {
    //       this.alarmTypeList.push({
    //         label: response.data.alarmTypes[i].alarmTypeName,
    //         value: response.data.alarmTypes[i].alarmTypeIds,
    //         checked: false
    //       });
    //     }
    //   }
    // });
  }
};
</script>
